var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5H1C0.867392 0.5 0.740215 0.552679 0.646447 0.646447C0.552678 0.740215 0.5 0.867392 0.5 1V9.5C0.5 9.76522 0.605357 10.0196 0.792893 10.2071C0.98043 10.3946 1.23478 10.5 1.5 10.5H12.5C12.7652 10.5 13.0196 10.3946 13.2071 10.2071C13.3946 10.0196 13.5 9.76522 13.5 9.5V1C13.5 0.867392 13.4473 0.740215 13.3536 0.646447C13.2598 0.552679 13.1326 0.5 13 0.5ZM7 5.82187L2.28562 1.5H11.7144L7 5.82187ZM5.16937 5.5L1.5 8.86312V2.13688L5.16937 5.5ZM5.90938 6.17813L6.65938 6.86875C6.75162 6.95343 6.87228 7.00041 6.9975 7.00041C7.12272 7.00041 7.24338 6.95343 7.33562 6.86875L8.08562 6.17813L11.7106 9.5H2.28562L5.90938 6.17813ZM8.83062 5.5L12.5 2.13625V8.86375L8.83062 5.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.97c063a93a902b0b30748d5d82c55b1e.svg";
export { ForwardRef as ReactComponent };